export default "__VITE_ASSET__Czkx7g7w__"